// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/css/bootstrap.min.css
// module id = 1862
// module chunks = 4